<template>
  <v-card>
    <v-card-title>
      <span class="headline mt-2"
        ><h1>Политика обработки персональных данных</h1></span
      >
    </v-card-title>
    <v-card-text>
      <div clss="clear"></div>

      <p align="right" style="clear: both;">
        <strong>
          <em
            >Утверждена приказом генерального директора ООО «Эффективные
            технологии» от 09.01.2016 г.</em
          >
        </strong>
      </p>

      <h4>1. Назначение и область действия</h4>

      <p>
        1.1. Настоящий документ (далее — Политика) определяет цели и общие
        принципы обработки персональных данных, а также реализуемые меры защиты
        персональных данных в ООО «Эффективные технологии» (далее — Оператор).
        Политика является общедоступным документом Оператора и предусматривает
        возможность ознакомления с ней любых лиц.
      </p>

      <p>
        1.2. Политика действует бессрочно после утверждения и до ее замены новой
        версией.
      </p>

      <p>
        1.3. В Политике используются термины и определения в соответствии с их
        значениями, как они определены в ФЗ-152 «О персональных данных».
      </p>

      <p>
        1.4. Политика распространяется на всех сотрудников Оператора (включая
        работников по трудовым договорам и сотрудников, работающих по договорам
        подряда) и все структурные подразделения Общества, включая обособленные
        подразделения. Требования Политики также учитываются и предъявляются в
        отношении иных лиц при необходимости их участия в процессе обработки
        персональных данных Оператором, а также в случаях передачи им в
        установленном порядке персональных данных на основании соглашений,
        договоров, поручений на обработку.
      </p>

      <h4>2. Сведения об обработке персональных данных</h4>

      <p>
        2.1. Обработка персональных данных Оператором ведется смешанным
        способом: с использованием средств автоматизации и без.
      </p>

      <p>
        2.2. Действия с персональными данными включают сбор, запись,
        систематизацию, накопление, хранение, уточнение (обновление, изменение),
        извлечение, использование, передача (распространение, предоставление,
        доступ), обезличивание, блокирование, удаление, уничтожение персональных
        данных.
      </p>

      <p>
        2.3. Обработка персональных данных осуществляется Оператором на законной
        и справедливой основе, правовыми основания для обработки являются:
      </p>

      <ul>
        <li>Конституция Российской Федерации;</li>
        <li>Трудовой кодекс Российской Федерации;</li>
        <li>Гражданский кодекс Российской Федерации;</li>
        <li>Налоговый кодекс Российской Федерации;</li>
        <li>
          Федеральный закон от 27.07.2006г. № 152-ФЗ «О персональных данных»;
        </li>
        <li>
          Федеральный закон от 10.01.2002г. № 1-ФЗ «Об электронной цифровой
          подписи»;
        </li>
        <li>
          Федеральный закон от 06.04.2011г. № 63-ФЗ «Об электронной подписи»;
        </li>
        <li>
          Федеральный закон от 04.05.2011г. № 99-ФЗ «О лицензировании отдельных
          видов деятельности»;
        </li>
        <li>Федеральный закон от 07.07.2003г. № 126-ФЗ «О связи»;</li>
        <li>
          Федеральный закон от 01.04.1996г. № 27-ФЗ «Об индивидуальном
          (персонифицированном) учете в системе обязательного пенсионного
          страхования»;
        </li>
        <li>
          Федеральный закон от 24.07.2009г. № 212-ФЗ «О страховых взносах в
          Пенсионный Фонд РФ, Фонд социального страхования РФ, Федеральный Фонд
          обязательного медицинского страхования и территориальные фонды
          обязательного медицинского страхования»;
        </li>
        <li>
          Федеральный закон от 22.10.2004г. № 125-ФЗ «Об архивном деле в РФ»;
        </li>
        <li>Закон РФ от 10.07.1992г. № 3266-1 «Об образовании»;</li>
        <li>Устав ООО «Эффективные технологии».</li>
      </ul>

      <p>
        2.4. Содержание и объем обрабатываемых персональных определяются исходя
        из целей обработки. Не обрабатываются персональные данные, избыточные
        или несовместимые по отношению к следующим основным целям:
      </p>

      <ul>
        <li>заключение трудовых отношений с физическими лицами;</li>
        <li>выполнение договорных обязательств Оператора;</li>
        <li>
          соблюдение действующего трудового, бухгалтерского, пенсионного, иного
          законодательства Российской Федерации.
        </li>
      </ul>

      <p>
        2.5. К основным категориям субъектов персональных данных, чьи данные
        обрабатываются Оператором, относятся:
      </p>

      <ul>
        <li>
          физические лица, состоящие в трудовых и гражданско-правовых отношениях
          с Оператором;
        </li>
        <li>
          физические лица, состоящие в трудовых и гражданско-правовых отношениях
          с контрагентами Оператора;
        </li>
        <li>физические лица - кандидаты на замещение вакантных должностей.</li>
      </ul>

      <p>
        2.6. Для указанных категорий субъектов могут обрабатываться: фамилия,
        имя, отчество; год, месяц, дата рождения; место рождения, адрес;
        семейное положение; социальное положение; имущественное положение;
        образование; профессия; доходы; ИНН, СНИЛС, контактная информация
        (телефон, адрес электронной почты), иные сведения, предусмотренные
        типовыми формами и установленным порядком обработки.
      </p>

      <p>
        2.7. При обработке обеспечиваются точность персональных данных, их
        достаточность и актуальность по отношению к целям обработки персональных
        данных. При обнаружении неточных или неполных персональных данных
        производится их уточнение и актуализация.
      </p>

      <p>
        2.8. Для персональных данных, не являющихся общедоступными,
        обеспечивается конфиденциальность.
      </p>

      <p>
        2.9. Обработка и хранение персональных данных осуществляются не дольше,
        чем этого требуют цели обработки персональных данных, если отсутствуют
        законные основания для дальнейшей обработки, например, если федеральным
        законом или договором с субъектом персональных данных не установлен
        соответствующий срок хранения. Обрабатываемые персональные данные
        подлежат уничтожению либо обезличиванию при наступлении следующий
        условий:
      </p>

      <ul>
        <li>
          достижение целей обработки персональных данных или максимальных сроков
          хранения — в течение 30 дней;
        </li>
        <li>
          утрата необходимости в достижении целей обработки персональных данных
          — в течение 30 дней;
        </li>
        <li>
          предоставление субъектом персональных данных или его законным
          представителем подтверждения того, что персональные данные являются
          незаконно полученными или не являются необходимыми для заявленной цели
          обработки — в течение 7 дней;
        </li>
        <li>
          невозможность обеспечения правомерности обработки персональных данных
          — в течение 10 дней;
        </li>
        <li>
          отзыв субъектом персональных данных согласия на обработку персональных
          данных, если сохранение персональных данных более не требуется для
          целей обработки персональных данных — в течение 30 дней;
        </li>
        <li>
          отзыв субъектом персональных данных согласия на использование
          персональных данных для контактов с потенциальными потребителями при
          продвижении товаров и услуг — в течение 2 дней;
        </li>
        <li>
          истечение сроков исковой давности для правоотношений, в рамках которых
          осуществляется либо осуществлялась обработка персональных данных;
        </li>
        <li>ликвидация (реорганизация) Оператора.</li>
      </ul>

      <p>
        2.10. Обработка персональных данных на основании договоров и иных
        соглашений Оператора, поручений Оператору и поручений Оператора на
        обработку персональных данных осуществляется в соответствии с условиями
        этих договоров, соглашений Оператора, а также соглашений с лицами,
        которым поручена обработка или которые поручили обработку на законных
        основаниях. Такие соглашения могут определять, в частности:
      </p>

      <ul>
        <li>цели, условия, сроки обработки персональных данных;</li>
        <li>
          обязательства сторон, в том числе меры по обеспечению
          конфиденциальности;
        </li>
        <li>
          права, обязанности и ответственность сторон, касающиеся обработки
          персональных данных.
        </li>
      </ul>

      <p>
        2.11. В случаях, не предусмотренных явно действующим законодательством
        или договором, обработка осуществляется после получения согласия
        субъекта персональных данных. Согласие может быть выражено в форме
        совершения действий, принятия условий договора-оферты, проставления
        соответствующих отметок, заполнения полей в формах, бланках, или
        оформлено в письменной форме в соответствии с законодательством.
      </p>

      <p>
        2.12. Оператор в установленном порядке проходит регистрацию в реестре
        уполномоченного органа по защите прав субъектов персональных данных. В
        реестре должны быть указаны сведения об Операторе, в том числе: полное
        наименование, контактная информация для обращений, сведения об обработке
        персональных данных и мерах по обеспечению безопасности.
      </p>

      <h4>3. Меры по обеспечению безопасности персональных данных</h4>

      <p>
        3.1. Оператор предпринимает необходимые правовые, организационные и
        технические меры для обеспечения безопасности персональных данных для их
        защиты от несанкционированного (в том числе, случайного) доступа,
        уничтожения, изменения, блокирования доступа и других
        несанкционированных действий. К таким мерам, в частности, относятся:
      </p>

      <ul>
        <li>
          назначение сотрудников, ответственных за организацию обработки и
          обеспечение безопасности персональных данных;
        </li>
        <li>
          проверка наличия в договорах и включение при необходимости в договоры
          пунктов об обеспечении конфиденциальности персональных данных;
        </li>
        <li>
          издание локальных актов по вопросам обработки персональных данных,
          ознакомление с ними работников, обучение пользователей;
        </li>
        <li>
          обеспечение физической безопасности помещений и средств обработки;
        </li>
        <li>
          ограничение и разграничение доступа сотрудников и иных лиц к
          персональным данным и средствам обработки, мониторинг действий с
          персональными данными;
        </li>
        <li>
          определение угроз безопасности персональных данных при их обработке,
          формирование на их основе моделей угроз;
        </li>
        <li>
          применение средств обеспечения безопасности (антивирусных средств,
          межсетевых экранов, средств защиты от несанкционированного доступа,
          средств криптографической защиты информации), в том числе прошедших
          процедуру оценки соответствия в установленном порядке;
        </li>
        <li>
          учёт и хранение носителей информации, исключающее их хищение, подмену,
          несанкционированное копирование и уничтожение;
        </li>
        <li>
          резервное копирование информации для возможности восстановления;
        </li>
        <li>
          осуществление внутреннего контроля за соблюдением установленного
          порядка, проверка эффективности принятых мер, реагирование на
          обращения.
        </li>
      </ul>

      <h4>4. Права субъектов персональных данных</h4>

      <p>
        4.1. Субъект персональных данных имеет право отозвать согласие на
        обработку персональных данных, направив соответствующий запрос Оператору
        по почте или обратившись лично.
      </p>

      <p>
        4.2. Субъект персональных данных имеет право на получение информации,
        касающейся обработки его персональных данных, в том числе содержащей:
      </p>

      <ul>
        <li>подтверждение факта обработки персональных данных Оператором;</li>
        <li>правовые основания и цели обработки персональных данных;</li>
        <li>
          цели и применяемые Оператором способы обработки персональных данных;
        </li>
        <li>
          наименование и место нахождения Оператора, сведения о лицах (за
          исключением сотрудников/работников Оператора), которые имеют доступ к
          персональным данным или которым могут быть раскрыты персональные
          данные на основании договора с Оператором или на основании
          федерального закона;
        </li>
        <li>
          обрабатываемые персональные данные, относящиеся к соответствующему
          субъекту персональных данных, источник их получения, если иной порядок
          представления таких данных не предусмотрен федеральным законом;
        </li>
        <li>
          сроки обработки персональных данных, в том числе сроки их хранения;
        </li>
        <li>
          порядок осуществления субъектом персональных данных прав,
          предусмотренных Федеральным законом «О персональных данных»;
        </li>
        <li>
          информацию об осуществленной или о предполагаемой трансграничной
          передаче данных;
        </li>
        <li>
          наименование или фамилию, имя, отчество и адрес лица, осуществляющего
          обработку персональных данных по поручению Оператора, если обработка
          поручена или будет поручена такому лицу;
        </li>
        <li>
          иные сведения, предусмотренные Федеральным законом «О персональных
          данных» или другими федеральными законами.
        </li>
      </ul>

      <p>
        4.3. Субъект персональных данных вправе требовать от Оператора уточнения
        его персональных данных, их блокирования или уничтожения в случае, если
        персональные данные являются неполными, устаревшими, неточными,
        незаконно полученными или не являются необходимыми для заявленной цели
        обработки, а также принимать предусмотренные законом меры по защите
        своих прав.
      </p>

      <p>
        4.4. Если субъект персональных данных считает, что Оператор осуществляет
        обработку его персональных данных с нарушением требований Федерального
        закона «О персональных данных» или иным образом нарушает его права и
        свободы, субъект персональных данных вправе обжаловать действия или
        бездействие Оператора в уполномоченный орган по защите прав субъектов
        персональных данных (Федеральная служба по надзору в сфере связи,
        информационных технологий и массовых коммуникаций — Роскомнадзор)
        или&nbsp; судебном порядке.
      </p>

      <p>
        4.5. Субъект персональных данных имеет право на защиту своих прав и
        законных интересов, в том числе на возмещение убытков и (или)
        компенсацию морального вреда в судебном порядке.
      </p>

      <h4>5. Роли и ответственность</h4>

      <p>
        5.1. Права и обязанности Оператора определяются действующим
        законодательством и соглашениями Оператора.
      </p>

      <p>
        5.2. Контроль исполнения требований настоящей Политики осуществляется
        ответственным за организацию обработки персональных данных и Отделом
        информационной безопасности Оператора в пределах их полномочий.
      </p>

      <p>
        5.3. Ответственность лиц, участвующих в обработке персональных данных на
        основании поручений Оператора, за неправомерное использование
        персональных данных устанавливается в соответствии с условиями
        заключенного между Оператором и контрагентом гражданско-правового
        договора или Соглашения о конфиденциальности информации.
      </p>

      <p>
        5.4. Лица, виновные в нарушении норм, регулирующих обработку и защиту
        персональных данных, несут материальную, дисциплинарную,
        административную, гражданско-правовую или уголовную ответственность в
        порядке, установленном федеральными законами, локальными актами,
        соглашениями Оператора.
      </p>

      <p>
        5.5. Политика разрабатывается ответственным за организацию обработки
        персональных данных и вводится в действие после утверждения
        руководителем Оператора. Предложения и замечания для внесения изменений
        в Политику следует направлять по адресу
        <a href="mailto:help@finexpert.pro">help@finexpert.pro</a>. Политика
        пересматривается ежегодно для поддержания в актуальном состоянии и
        актуализируется по мере необходимости.
      </p>

      <div id="thumbnails">
        <ul></ul>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="$emit('close', false)"
        >Закрыть</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: 'register_police'
};
</script>

<style></style>
